import { Injectable } from "@angular/core";
import { ServiceBase } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { DivisaoHonorariosFiltros, DivisaoHonrariosDTO } from "@app/models/divisao-honorarios.model";
import { EdicaoDivisaoHonorarioInput, VincularDivisaoInput } from "@app/models/receber-divisao-honorarios.model";



@Injectable()

export class DivisaoHonorariosService extends ServiceBase {

  constructor(private http: HttpClient) {
    super();
  }

  BuscarTitulosVinculadosDoProcesso(processoId: number) {
    return this.http.get<any>(this.URL_API + `divisaoHonorarios/BuscarTitulosVinculadosDoProcesso?processoId=${processoId}`);
  }

  EditarDivisaoHonorarios(divisaoEdicao: EdicaoDivisaoHonorarioInput): Observable<any> {
    return this.http.post<any>(this.URL_API + "divisaoHonorarios/Editar", divisaoEdicao);
  }

  VincularDivisaoHonorarios(divisaoVincular: VincularDivisaoInput): Observable<any> {
    //stringify necessário para trafegar o Map corretamente
    divisaoVincular.MapStringAdvogadosHonorarios = JSON.stringify(Array.from(divisaoVincular.AdvogadosHonorarios.entries()));
    return this.http.post<any>(this.URL_API + "divisaoHonorarios/Vincular", divisaoVincular);
  }

  ExcluirDivisao(divisaoID: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `divisaoHonorarios/ExcluirDivisao?divisaoID=${divisaoID}`);
  }

  DetalharDivisaoHonorario(divisaoID: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `divisaoHonorarios/DetalharDivisao?divisaoID=${divisaoID}`);
  }

  ListarDivisaoHonorarios(filtros: DivisaoHonorariosFiltros): Observable<any> {
    return this.http.post<any>(this.URL_API + "divisaoHonorarios/ListarDivisaoHonorario", filtros);
  }
}